import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'card-number-renderer',
    templateUrl: './card-number-renderer.component.html',
    standalone: true,
    imports: []
})
export class CardNumberRendererComponent implements ICellRendererAngularComp {
    public cardNumber: number;

    constructor() { }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

    initilize(params: ICellRendererParams) {
        this.cardNumber = this.getCardNoForDisplay(params.getValue());
    }

    getCardNoForDisplay(cardNo) {
        if (cardNo != null && cardNo != "") {
            var cardWithX = "XXXXXXXXXXXXXXXX" + cardNo;
            cardNo = cardWithX.substring(cardWithX.length - 16, cardWithX.length);
        }
        return cardNo;
    }
}
